import React, {useState, useEffect} from 'react'
import Form from 'react-bootstrap/Form'
import {changePassword} from '../../../api/modules/auth'
import {useNavigate} from 'react-router-dom'
import {useTranslation, initReactI18next} from 'react-i18next'
import swal from 'sweetalert'
import i18next from 'i18next'

const ChangePassword: React.FC = () => {
  // const {t} = useTranslation()

  const [passLama, setPassLama] = useState('')
  const [passBaru, setPassBaru] = useState('')
  const [passconfirm, setPassconfirm] = useState('')

  const navigate = useNavigate()

  const changePass = async () => {
    await changePassword({
      password: passBaru,
      password_confirmation: passconfirm,
      password_old: passLama,
      lang: i18next.language,
    })
      .then((res) => {
        swal({
          icon: 'success',
          title: t(res.data.message),
        })
        // alert(res.data.message)
        navigate('/dashboard')
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            icon: 'error',
            title: t(error.response.data.message),
          })
          // alert(error.response.data.message)
        }
      })
  }

  const {t} = useTranslation()

  return (
    <div className='card p-5'>
      {/* begin::Header */}
      <div className='card-header m-0 d-flex align-items-center'>
        <h3 className='fw-bolder m-0'>{t('Change')} Password</h3>
      </div>
      <div
        className='w-lg-700px bg-body rounded shadow-lg p-10 p-lg-15 mx-auto'
        style={{marginTop: '4rem', marginBottom: '4rem'}}
      >
        <div className='form w-100'>
          <div className='mb-10'>
            <p className='text-gray-400 h6' style={{fontSize: 10}}>
              {t('max-pass')}
            </p>

            <p className='text-gray-400 h6 mt-1' style={{fontSize: 10}}>
              {t('confirm-pass')}
            </p>
          </div>

          <div className='fv-row mb-10'>
            <Form.Control
              type='password'
              placeholder={t('Old-pass')}
              autoComplete='off'
              onChange={(e: any) => setPassLama(e.target.value)}
            />
          </div>

          <div className='fv-row mb-10'>
            <Form.Control
              type='password'
              placeholder={t('New-pass')}
              autoComplete='off'
              onChange={(e: any) => setPassBaru(e.target.value)}
            />
          </div>

          <div className='fv-row mb-10'>
            <span
              className='text-danger'
              hidden={passBaru != passconfirm && passconfirm ? false : true}
            >
              {t('pass-not')}
            </span>
            <Form.Control
              type='password'
              placeholder={t('Confirm-pass')}
              autoComplete='off'
              onChange={(e: any) => setPassconfirm(e.target.value)}
            />
          </div>

          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button
              onClick={() => changePass()}
              id='kt_password_reset_submit'
              className='btn btn-lg btn-primary fw-bolder me-4'
            >
              <span className='indicator-label'>{t('submit')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ChangePassword}
